import React, { useEffect, useState, useRef } from "react";
import "./dashboard.scss";
import DataTable from "./DataTable/DataTable";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
// import axios from 'axios';
import { Api_Url } from "../../../utils/ApiUrl";
import { useHistory } from "react-router-dom";
import { chartData } from "../../../redux/action";
import { useDispatch } from "react-redux";

import Web3 from "web3";
import { toast } from "react-toastify";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";
import { DateRange } from "react-date-range";
import { useDetectClickOutside } from "react-detect-click-outside";
import { CopyToClipboard } from "react-copy-to-clipboard";
import CurrentRound from "../../../hooks/dataFetchers/round";
import tableup from "../../../assets/tableup.svg";
import tabledown from "../../../assets/tabledown.svg";
import { useSelector } from "react-redux";

import moment from "moment";
import Countrychart from "./CountryChart";
import useAdminAllowed from "../../../hooks/userManagement/useAdminAllowed";

const Dashboard = ({
  user,
  setUser,
  tomiPrice,
  usdPrice,
  btcPrice,
  pepePrice,
  linkPrice,
  uniPrice,
  dopPrice,
  gemsPrice,
  hitfunctionss,
}) => {
  let userRole = user?.role;
  const goldenUserData = useSelector((state) => state?.user?.users);
  // // console.log(
  //   goldenUserData,
  //   "   gemsLockedGolden  gemsLockedGolden gemsLockedGolden gemsLockedGolden gemsLockedGolden"
  // );

  const [project, setProject] = useState("MINER");
  const dispatch = useDispatch();

  const projectPercentage = {
    DOP: 0.05,
    GEMS: 0.05,
    LEIA: 0.05,
    OLYMPUS: 0.05,
    INCENTIV: 0.05,
    NFA: 0.1,
  };

  const [topTenApiCalled, setTopTenApiCalled] = useState(false);
  const [transactionApiCalled, setTransactionApiCalled] = useState(false);
  const { currentRound } = CurrentRound();
  const [totalRound, setTotalRound] = useState([]);
  const checkAdminPermission = useAdminAllowed();
  const [codeDataCall, setCodeDataCall] = useState();
  const tok = localStorage?.getItem("accessToken");
  const [data, setData] = useState([]);
  const [totalT, setTotalT] = useState(0);
  const [welcome, setwelcome] = useState();
  const [purchases, setPurchases] = useState(null);
  const [earnings, setEarnings] = useState(null);
  const [netRevenue, setnetRevenue] = useState(null);
  // const [usdPrice, setUsdPrice] = useState(0);
  // // console.log("sdfdsfsdf", usdPrice)
  // const [tomiPrice, setchange24hr1] = useState(0);
  const [transactions, setTransactions] = useState([]);

  const [otherLeadersPurchasedAmount, setOtherLeadersPurchasedAmount] =
    useState([]);
  const [selectedRounds, setSelectedRounds] = useState([]);

  const [userselectdate, setuserselectdate] = useState(false);
  const [pc, setPC] = useState(0);
  const [pmc, setPMC] = useState(0);
  const [nrc, setNRC] = useState(0);
  const [lc, setLC] = useState(0);
  const [dpc, setDPC] = useState(0);
  const [lec, setLEC] = useState(0);
  const [a, seta] = useState(0);
  const [m, setm] = useState(0);
  const [s, sets] = useState(0);
  const [g, setg] = useState(0);
  const [gmini, setgmini] = useState(0);

  const [protTrxCh, setProtTrxCh] = useState(0);

  const [protAmountCh, setProtAmountCh] = useState(0);

  const [protNftAmountCh, setProtNftAmountCh] = useState(0);

  const [ind, setIND] = useState(0);
  const [dt, setDT] = useState(0);
  const [totalleader, settotalleader] = useState(0);
  const [activeleader, setactiveleader] = useState(0);
  const [round, setRound] = useState([]);

  const [dops, setDops] = useState(null);
  // const [dopPrice, setDopPrice] = useState(0);
  const [search, setSearch] = useState("");
  const [topLeaderSearch, setTopLeaderSearch] = useState("");

  const [dataTime, setDataTime] = useState("1");
  const [dataTimeTop, setDataTimeTop] = useState("1");
  const [showtext, SetShowtext] = useState(false);

  const [orderField, setOrderField] = useState("transactionTime");
  const [orderDirection, setOrderDirection] = useState("-1");
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState([]);

  const [tokenNftStats, setTokenNftStats] = useState();
  // const [tomiPrice, setTomiPrice] = useState("");
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: null,
      key: "selection",
    },
  ]);

  const [statsData, setStatsData] = useState({});

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [showcalendar, setShowCalendar] = useState(false);
  const [chartsData, setChartsData] = useState();

  const history = useHistory();

  const [loader, setLoader] = useState(false);
  const [alllset, setalllset] = useState("1");
  const [show, setShow] = useState(false);
  const [agents, setAgents] = useState([]);
  const [name, setName] = useState("");
  const [role, setRole] = useState(null);
  const [addr, setAddr] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => {
    setName("");
    setAddr("");
    setEmail("");
    // setRole(null);
    setShow1(false);
  };
  const [refLists, setRefLists] = useState([]);

  const [selectedItem, setSelectedItem] = useState({
    imgSrc: "/assets/minericon.svg",
    text: "MINER",
  });
  const [activeTab, setActiveTab] = useState("home-tab");
  const [topTenLeaders, setTopTenLeaders] = useState([]);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => {
    setShow2(false);
    setRole(null);
  };
  const handleItemClick = (imgSrc, text) => {
    setSelectedItem({ imgSrc, text });
    setProject(text);
  };
  const toggleRoundSelection = (round) => {
    setSelectedRounds(
      (prevRounds) =>
        prevRounds.includes(round)
          ? prevRounds.filter((r) => r !== round) // Remove if already selected
          : [...prevRounds, round] // Add if not selected
    );
  };
  function isValidEmail(email) {
    var pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return pattern.test(email);
  }

  function isAddressValid(address) {
    return Web3.utils.isAddress(address);
  }

  const AddAgent = async() => {
    // await checkAdminPermission();
    const lowerCaseEmail = email.toLowerCase();
    const val = localStorage.getItem("accessToken");
    let url = null;
    if (user?.role === "admin") {
      url = `${Api_Url}/users/god-agents`;
    } else if (role === "mega_agent") {
      url = `${Api_Url}/users/mega-agents`;
    } else if (role === "super_agent") {
      url = `${Api_Url}/users/super-agents`;
    } else if (role === "agent") {
      url = `${Api_Url}/users/agents`;
    } else if (role === "mini_agent") {
      url = `${Api_Url}/users/mini-agents`;
    }
    if (name?.length > 2) {
      if (isAddressValid(addr)) {
        if (isValidEmail(email)) {
          setLoader(true);
          var config = {
            method: "post",
            url: url,
            data: {
              name: name,
              walletAddress: addr,
              email: lowerCaseEmail,
              name: name,
            },
            headers: {
              Authorization: "Bearer " + val,
            },
          };
          axios(config)
            .then(function (response) {
              setLoader(false);

              setName("");
              setAddr("");
              setEmail("");
              // setRole(null);
              handleClose1();
              setShow2(true);
            })
            .catch(function (error) {
              setLoader(false);
              setRole(null);

              toast.error(error?.response?.data?.message);
              if (error?.response?.status == 401) {
                // localStorage.removeItem("accessToken");
                // history.push("/");
              }
            });
        } else {
          setError("Incorrect Email!");
        }
      } else {
        setError("Incorrect wallet address!");
      }
    } else {
      setError("Name must be of length 3!");
    }
  };

  function convertToTitleCase(input) {
    if (input) {
      let words = input
        .split("_")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      if (words[0] === "mini" || words[0] === "Mini") {
        return "Ambassador";
      }
      if (
        words[words.length - 1].toLowerCase() === "agent" &&
        (words[0] != "mini" || words[0] != "Mini")
      ) {
        words[words.length - 1] = "Leader";
      }
      if (words[0] === "super" || words[0] === "Super") {
        return "Super";
      } else if (words[0] !== "agent") {
        return words.join(" ");
      } else {
        return "Leader";
      }
    } else {
      return "";
    }
  }

  const handlePageChange = (e) => {
    const selectedPage = e.selected;

    setPage(selectedPage);
  };

  const GetTopTenLeaders = async () => {
    var config = {
      method: "get",
      url: `${Api_Url}/users/top-leaders?limit=10&privateSale=NODEMINER`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };

    let dynamicQuery = config.url;

    if (startDate && startDate != null) {
      dynamicQuery += `&startDate=${startDate}&endDate=${endDate}`;
    }

    config.url = dynamicQuery;

    axios(config)
      .then(function (response) {
        setTopTenLeaders(response?.data?.data);
        setTopTenApiCalled(true);
      })
      .catch(function (error) {
        setTopTenApiCalled(true);

        // console.log(error);
      });

    // }
  };

  const getTransactionsData = () => {
    setLoader(true);

    var config = {
      method: "get",
      url: `${Api_Url}/nodeminer/transactions?privateSale=${project}&limit=10&offset=1&orderField=transactionTime&orderDirection=-1`,

      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    axios(config)
      .then(function (res) {
        // console.log("trx data: ", res?.data?.data?.transactions);
        setTransactions(res?.data?.data?.transactions);
        setPageCount(res?.data?.data?.pages);
        // setTransactionApiCalled(false);
        setLoader(false);

        // setLoader(false);
      })
      .catch(function (error) {
        // setTransactionApiCalled(true);

        setLoader(false);
      });
  };

  const [adminobj, setadminobj] = useState();

  useEffect(() => {
    if (tok && activeTab == "profile-tab") {
      GetTopTenLeaders();
    }
  }, [startDate, endDate, activeTab]);

  useEffect(() => {
    if (tok) {
      getTransactionsData();
    }
  }, [usdPrice, user, search, orderField, orderDirection, round, project]);

  useEffect(() => {
    if (usdPrice) {
      if (user?.role == "admin") {
        setwelcome("Admin");
        // GetDashboardData1();
        // GetChartsData();
      }
    }
  }, [user]);

  // Admin data upper stats

  const GetDashboardData = () => {
    var config = {
      method: "get",
      url: `${Api_Url}/nodeminer/stats?privateSale=${selectedItem?.text}`,
      // url: `${Api_Url}/users/leader-counts?startDate=${stDate}&&endDate=${enDate}`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };

    let dynamicQuery = config.url;

    if (startDate && startDate != null) {
      dynamicQuery += `&startDate=${startDate}&endDate=${endDate}`;
    }
    if (startDate && startDate != null && selectedRounds?.length > 0) {
      dynamicQuery += `&round=${selectedRounds}`;
    } else if (selectedRounds?.length > 0) {
      dynamicQuery += `?round=${selectedRounds}`;
    }

    config.url = dynamicQuery;

    axios(config)
      .then(function (response) {
        // setChartsData(resData);
        if (response?.data?.data?.data?.stats?.length > 0) {
          setadminobj(response?.data?.data?.data?.stats[0]);
        } else {
          setadminobj();
        }
        let value = response?.data?.data;
        // console.log("value: ", value);
        setStatsData(value);
        // if (times) {
        let purchaseChange =
          ((value?.stats[0]?.count - value?.oldStats[0]?.count) /
            value?.oldStats[0]?.count) *
          100;
        setPC(purchaseChange);

        let newPurchasedAmount =
          value?.stats[0]?.totalPurchaseEth * usdPrice +
          value?.stats[0]?.totalPurchaseUsdt;
        let oldPurchasedAmount =
          value?.oldStats[0]?.totalPurchaseEth * usdPrice +
          value?.oldStats[0]?.totalPurchaseUsdt;

        let purchasedAmountChange = 0;

        if (newPurchasedAmount === 0 && oldPurchasedAmount === 0) {
          purchasedAmountChange = 0;
        } else if (newPurchasedAmount === 0 || oldPurchasedAmount === 0) {
          if (newPurchasedAmount === 0) {
            purchasedAmountChange =
              ((0 - oldPurchasedAmount) / oldPurchasedAmount) * 100;
          }
          if (oldPurchasedAmount === 0) {
            purchasedAmountChange = ((newPurchasedAmount + 1 - 1) / 1) * 100;
          }
        } else {
          purchasedAmountChange =
            ((newPurchasedAmount - oldPurchasedAmount) / oldPurchasedAmount) *
            100;
        }

        setPMC(purchasedAmountChange);

        let newProtectTransactions = value?.protectedStats[0]?.purchases || 0;

        let oldProtectTransactions =
          value?.protectedOldStats[0]?.purchases || 0;

        let protectTransactionsChange = 0;

        if (newProtectTransactions === 0 && oldProtectTransactions === 0) {
          protectTransactionsChange = 0;
        } else if (
          newProtectTransactions === 0 ||
          oldProtectTransactions === 0
        ) {
          if (newProtectTransactions === 0) {
            protectTransactionsChange =
              ((0 - oldProtectTransactions) / oldProtectTransactions) * 100;
          }
          if (oldProtectTransactions === 0) {
            protectTransactionsChange =
              ((newProtectTransactions + 1 - 1) / 1) * 100;
          }
        } else {
          protectTransactionsChange =
            ((newProtectTransactions - oldProtectTransactions) /
              oldProtectTransactions) *
            100;
        }

        setProtTrxCh(protectTransactionsChange);

        let newProtectAmount =
          value?.protectedStats[0]?.totalSaleConverted || 0;

        let oldProtectAmount =
          value?.protectedOldStats[0]?.totalSaleConverted || 0;

        let protectAmountChange = 0;

        if (newProtectAmount === 0 && oldProtectAmount === 0) {
          protectAmountChange = 0;
        } else if (newProtectAmount === 0 || oldProtectAmount === 0) {
          if (newProtectAmount === 0) {
            protectAmountChange =
              ((0 - oldProtectAmount) / oldProtectAmount) * 100;
          }
          if (oldProtectAmount === 0) {
            protectAmountChange = ((newProtectAmount + 1 - 1) / 1) * 100;
          }
        } else {
          protectAmountChange =
            ((newProtectAmount - oldProtectAmount) / oldProtectAmount) * 100;
        }

        setProtAmountCh(protectAmountChange);

        let newProtectNftAmount = value?.protectedStats[0]?.totalNftSum || 0;

        let oldProtectNftAmount = value?.protectedOldStats[0]?.totalNftSum || 0;

        let protectNftAmountChange = 0;

        if (newProtectNftAmount === 0 && oldProtectNftAmount === 0) {
          protectNftAmountChange = 0;
        } else if (newProtectNftAmount === 0 || oldProtectNftAmount === 0) {
          if (newProtectNftAmount === 0) {
            protectNftAmountChange =
              ((0 - oldProtectNftAmount) / oldProtectNftAmount) * 100;
          }
          if (oldProtectNftAmount === 0) {
            protectNftAmountChange = ((newProtectNftAmount + 1 - 1) / 1) * 100;
          }
        } else {
          protectNftAmountChange =
            ((newProtectNftAmount - oldProtectNftAmount) /
              oldProtectNftAmount) *
            100;
        }

        setProtNftAmountCh(protectNftAmountChange);

        setNRC(value?.netRevenueChange);

        let newLeadersCount =
          value?.agents +
          value?.godAgents +
          value?.megaAgents +
          value?.superAgents +
          value?.miniAgents;
        let oldLeadersCount =
          value?.oldleaders +
          value?.oldgodLeaders +
          value?.oldmegaLeaders +
          value?.oldsuperLeaders +
          value?.oldminiLeaders;
        let leadersChange = 0;
        if (newLeadersCount === 0 && oldLeadersCount === 0) {
          leadersChange = 0;
        } else if (newLeadersCount === 0 || oldLeadersCount === 0) {
          if (newLeadersCount === 0) {
            leadersChange = ((0 - oldLeadersCount) / oldLeadersCount) * 100;
          }
          if (oldLeadersCount === 0) {
            leadersChange = ((newLeadersCount + 1 - 1) / 1) * 100;
          }
        } else {
          leadersChange =
            ((newLeadersCount - oldLeadersCount) / oldLeadersCount) * 100;
        }
        setLC(leadersChange);
        let dopChange =
          ((value?.stats[0]?.totalDopPurchased -
            value?.oldStats[0]?.totalDopPurchased) /
            value?.oldStats[0]?.totalDopPurchased) *
          100;
        setDPC(dopChange);

        let totalLeaderEarningsEthValueOld =
          value?.oldStats[0]?.totalLeaderEarningsEth * usdPrice;

        let totalLeaderEarningsEthValueNew =
          value?.stats[0]?.totalLeaderEarningsEth * usdPrice;

        let totalLeaderEarningsOldPrice =
          totalLeaderEarningsEthValueOld +
          value?.oldStats[0]?.totalLeaderEarningsUsdt;
        let totalLeaderEarningsNewPrice =
          totalLeaderEarningsEthValueNew +
          value?.stats[0]?.totalLeaderEarningsUsdt;

        let totalLeadersEarningChange = 0;

        if (
          totalLeaderEarningsNewPrice === 0 &&
          totalLeaderEarningsOldPrice === 0
        ) {
          totalLeadersEarningChange = 0;
        } else if (
          totalLeaderEarningsNewPrice === 0 ||
          totalLeaderEarningsOldPrice === 0
        ) {
          if (totalLeaderEarningsNewPrice === 0) {
            totalLeadersEarningChange =
              ((0 - totalLeaderEarningsOldPrice) /
                totalLeaderEarningsOldPrice) *
              100;
          }
          if (totalLeaderEarningsOldPrice === 0) {
            totalLeadersEarningChange =
              ((totalLeaderEarningsNewPrice + 1 - 1) / 1) * 100;
          }
        } else {
          totalLeadersEarningChange =
            ((totalLeaderEarningsNewPrice - totalLeaderEarningsOldPrice) /
              totalLeaderEarningsOldPrice) *
            100;
        }

        setLEC(totalLeadersEarningChange);
        // } else {
        setPC("");
        setPMC("");

        setNRC("");
        setLC("");
        setDPC("");
        setLEC("");
        // }

        seta(value?.agents);
        setg(value?.godAgents);
        setm(value?.megaAgents);
        sets(value?.superAgents);
        setgmini(value?.miniAgents);
      })
      .catch(function (error) {
        // console.log(error);
      });
  };

  const GetLeadersStatsData = () => {
    var config = {
      method: "get",
      url: `${Api_Url}/users/superadmin/stats?privateSale=NODEMINER`,
      // url: `${Api_Url}/users/leader-counts?startDate=${stDate}&&endDate=${enDate}`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };

    let dynamicQuery = config.url;

    if (startDate && startDate != null) {
      dynamicQuery += `&startDate=${startDate}&endDate=${endDate}`;
    }
    if (startDate && startDate != null && selectedRounds?.length > 0) {
      dynamicQuery += `&round=${selectedRounds}`;
    } else if (selectedRounds?.length > 0) {
      dynamicQuery += `?round=${selectedRounds}`;
    }

    config.url = dynamicQuery;

    axios(config)
      .then(function (response) {
        let value = response?.data?.data;
        // console.log("value: ", value);

        settotalleader(
          value?.agents +
            value?.godAgents +
            value?.megaAgents +
            value?.superAgents +
            value?.miniAgents
        );
        setactiveleader(value?.activeLeaders);
      })
      .catch(function (error) {
        // console.log(error);
      });
  };

  const GetChartsDataCalendar = () => {
    // setalllset();
    // setState(times);
    // let date = null;
    // let date1 = null;
    // if (times) {
    //   let a = new Date(times[0]?.startDate);
    //   let b = new Date(times[0]?.endDate);
    //   date = moment(a).utc().format("Y-MM-DDT00:00:00");
    //   date1 = moment(b).utc().format("Y-MM-DDT23:59:59");
    // }

    var config = {
      method: "get",
      url: `${Api_Url}/emails/country/stats/nodeminer?privateSale=${project}&limit=30`,
      // url: `${Api_Url}/users/leader-counts?startDate=${stDate}&&endDate=${enDate}`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };

    let dynamicQuery = config.url;

    if (startDate && startDate != null) {
      dynamicQuery += `&startDate=${startDate}&endDate=${endDate}`;
    }
    // if (round) {
    //   dynamicQuery += `&round=${round}`;
    // }

    config.url = dynamicQuery;

    axios(config)
      .then(function (response) {
        let resData = response?.data?.data;
        setChartsData(resData);
      })
      .catch(function (error) {
        // console.log(error);
      });
  };

  const firstTimeData = async () => {
    try {
      let b = await currentRound(project);

      if (b) {
        const result = [];
        for (let i = 1; i <= b; i++) {
          result.push(i);
        }
        setTotalRound(result);
      }
    } catch (err) {
      // console.log(err.message);
    }
  };

  // const closeDropdown = () => {
  //   // // console.log("ddddddd")
  //   setShowCalendar(!showcalendar);
  // };
  // const ref = useDetectClickOutside({ onTriggered: closeDropdown });
  // // console.log("ddddddd", showcalendar);

  const [copy, setCopy] = useState(false);
  const textCopiedFun2 = () => {
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, 1000);
  };

  const [hoveredElements, setHoveredElements] = useState({
    icon1: false,
    icon2: false,
    icon3: false,
    icon4: false,
    icon5: false,
    icon6: false,
  });
  const handleMouseEnter = (element) => {
    setHoveredElements({ ...hoveredElements, [element]: true });
    const isMobileView = window.innerWidth < 768;
    if (isMobileView) {
      setTimeout(() => {
        setHoveredElements({ ...hoveredElements, [element]: false });
      }, 5000);
    }
  };
  const handleMouseLeave = (element) => {
    setHoveredElements({ ...hoveredElements, [element]: false });
  };

  const [profitChange, setProfitChange] = useState("0");
  const [buybackChange, setBuybackChange] = useState("0");

  const [tokenInsuredChange, setTokenInsuredChange] = useState("0");
  const [insuredCountChange, setInsuredCountChange] = useState("0");

  useEffect(() => {
    localStorage.setItem("project", project);

    firstTimeData();
  }, [project]);

  useEffect(() => {
    formatDates("1");
  }, []);

  useEffect(() => {
    if (tok && selectedItem) {
      GetDashboardData();
      GetChartsDataCalendar();

      GetLeadersStatsData();
    }
  }, [
    selectedItem,
    startDate,
    endDate,
    round,
    project,
    selectedRounds?.length,
  ]);

  const formatDates = (times) => {
    let date = null;
    let date1 = null;
    if (Array.isArray(times)) {
      let a = new Date(times[0]?.startDate);
      let b = new Date(times[0]?.endDate);
      date = moment(a).format("Y-MM-DDT00:00:00");
      date1 = moment(b).format("Y-MM-DDT23:59:59");
    } else if (times == "1") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (times == "seven") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (times == "year") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (times == "month") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    }
    setStartDate(date);
    setEndDate(date1);
  };

  function formatTokenValue(tokenValue) {
    if (tokenValue >= 1000000) {
      return (tokenValue / 1000000)?.toFixed(2) + "M";
    } else if (tokenValue >= 1000) {
      return (tokenValue / 1000)?.toFixed(2) + "k";
    } else {
      return tokenValue?.toFixed(2);
    }
  }
  return (
    <>
      <section className="dashboard dashboardnodesandminers">
        <div className="custom-container">
          {user?.role == "admin" ? (
            <h3 className="welcomesss">Hi {welcome ? welcome : ""}</h3>
          ) : (
            ""
          )}

          <div className="mainbuttonsss">
            <div className="main-heading m-0">
              <div>
                {/* <p className="selfhead">Premium Projects</p> */}
                <p className="selfhead">Nodes & Miners</p>
                <h6>Dashboard</h6>
              </div>
            </div>
            <button className="gusvtsvtvtsvxs" onClick={() => setShow1(true)}>
              Add Leader
            </button>
            {user?.role == "admin" ? (
              <div className="parent-twice-custom">
                <div className="dropdown">
                  <button
                    className="btn btn-secondary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <div className="projectmain">
                      {selectedItem?.imgSrc && (
                        <img
                          src={selectedItem?.imgSrc}
                          alt="projectimg"
                          className="projectimg"
                          width={24}
                        />
                      )}
                      <p className="projectpara">{selectedItem?.text}</p>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="6" viewBox="0 0 13 6" fill="none">
  <path d="M0 0L2.22397e-07 2.5462L6.2 6L6.2 3.4538L0 0Z" fill="white"/>
  <path d="M12.3984 0L12.3984 2.5462L6.19844 6L6.19844 3.4538L12.3984 0Z" fill="white"/>
</svg>
                  </button>
                  <ul className="dropdown-menu">
                    {/* <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={() => handleItemClick("", "All Projects")}
                      >
                        All Projects
                      </a>
                    </li> */}

                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={() =>
                          handleItemClick("/assets/nodeicon.svg", "NODE")
                        }
                      >
                        <div className="projectmain">
                          <img
                            src="/assets/nodeicon.svg"
                            alt="projectimg"
                            className="projectimg"
                            width={24}
                          />
                          <p className="projectpara">Node</p>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={() =>
                          handleItemClick("/assets/minericon.svg", "MINER")
                        }
                      >
                        <div className="projectmain">
                          <img
                            src="/assets/minericon.svg"
                            alt="projectimg"
                            className="projectimg"
                            width={24}
                          />
                          <p className="projectpara">Miner</p>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="custom-tab-bar">
                  <a
                    onClick={() => {
                      setalllset("1");
                      setDataTime("1");
                      formatDates("1");
                    }}
                    className={alllset == "1" ? "active" : "noactive"}
                  >
                    1D
                  </a>
                  <a
                    onClick={() => {
                      setalllset("seven");
                      setDataTime("seven");
                      formatDates("seven");
                    }}
                    className={alllset == "seven" ? "active" : "noactive"}
                  >
                    7D
                  </a>
                  <a
                    onClick={() => {
                      setalllset("month");
                      setDataTime("month");
                      formatDates("month");
                    }}
                    className={alllset == "month" ? "active" : "noactive"}
                  >
                    1M
                  </a>
                  <a
                    onClick={() => {
                      setalllset("year");
                      setDataTime("year");
                      formatDates("year");
                    }}
                    className={alllset == "year" ? "active" : "noactive"}
                  >
                    1Y
                  </a>
                  <a
                    onClick={() => {
                      setalllset("all");
                      setDataTime("");
                      formatDates("");
                    }}
                    className={alllset == "all" ? "active" : "noactive"}
                  >
                    All
                  </a>
                  <a onClick={() => setShowCalendar(!showcalendar)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                    >
                      <path
                        d="M17.0831 3.56V2C17.0831 1.59 16.7431 1.25 16.3331 1.25C15.9231 1.25 15.5831 1.59 15.5831 2V3.5H9.08312V2C9.08312 1.59 8.74311 1.25 8.33312 1.25C7.92312 1.25 7.58312 1.59 7.58312 2V3.56C4.88312 3.81 3.57311 5.42 3.37311 7.81C3.35311 8.1 3.59311 8.34 3.87311 8.34H20.7931C21.0831 8.34 21.3231 8.09 21.2931 7.81C21.0931 5.42 19.7831 3.81 17.0831 3.56Z"
                        fill="#8C8C8C"
                      />
                      <path
                        d="M20.3331 9.83984H4.33313C3.78313 9.83984 3.33313 10.2898 3.33313 10.8398V16.9998C3.33313 19.9998 4.83313 21.9998 8.33313 21.9998H16.3331C19.8331 21.9998 21.3331 19.9998 21.3331 16.9998V10.8398C21.3331 10.2898 20.8831 9.83984 20.3331 9.83984ZM9.54313 18.2098C9.49313 18.2498 9.44313 18.2998 9.39313 18.3298C9.33313 18.3698 9.27313 18.3998 9.21313 18.4198C9.15313 18.4498 9.09313 18.4698 9.03313 18.4798C8.96313 18.4898 8.90313 18.4998 8.83313 18.4998C8.70313 18.4998 8.57313 18.4698 8.45313 18.4198C8.32313 18.3698 8.22313 18.2998 8.12313 18.2098C7.94313 18.0198 7.83313 17.7598 7.83313 17.4998C7.83313 17.2398 7.94313 16.9798 8.12313 16.7898C8.22313 16.6998 8.32313 16.6298 8.45313 16.5798C8.63313 16.4998 8.83313 16.4798 9.03313 16.5198C9.09313 16.5298 9.15313 16.5498 9.21313 16.5798C9.27313 16.5998 9.33313 16.6298 9.39313 16.6698C9.44313 16.7098 9.49313 16.7498 9.54313 16.7898C9.72313 16.9798 9.83313 17.2398 9.83313 17.4998C9.83313 17.7598 9.72313 18.0198 9.54313 18.2098ZM9.54313 14.7098C9.35313 14.8898 9.09313 14.9998 8.83313 14.9998C8.57313 14.9998 8.31313 14.8898 8.12313 14.7098C7.94313 14.5198 7.83313 14.2598 7.83313 13.9998C7.83313 13.7398 7.94313 13.4798 8.12313 13.2898C8.40313 13.0098 8.84313 12.9198 9.21313 13.0798C9.34313 13.1298 9.45313 13.1998 9.54313 13.2898C9.72313 13.4798 9.83313 13.7398 9.83313 13.9998C9.83313 14.2598 9.72313 14.5198 9.54313 14.7098ZM13.0431 18.2098C12.8531 18.3898 12.5931 18.4998 12.3331 18.4998C12.0731 18.4998 11.8131 18.3898 11.6231 18.2098C11.4431 18.0198 11.3331 17.7598 11.3331 17.4998C11.3331 17.2398 11.4431 16.9798 11.6231 16.7898C11.9931 16.4198 12.6731 16.4198 13.0431 16.7898C13.2231 16.9798 13.3331 17.2398 13.3331 17.4998C13.3331 17.7598 13.2231 18.0198 13.0431 18.2098ZM13.0431 14.7098C12.9931 14.7498 12.9431 14.7898 12.8931 14.8298C12.8331 14.8698 12.7731 14.8998 12.7131 14.9198C12.6531 14.9498 12.5931 14.9698 12.5331 14.9798C12.4631 14.9898 12.4031 14.9998 12.3331 14.9998C12.0731 14.9998 11.8131 14.8898 11.6231 14.7098C11.4431 14.5198 11.3331 14.2598 11.3331 13.9998C11.3331 13.7398 11.4431 13.4798 11.6231 13.2898C11.7131 13.1998 11.8231 13.1298 11.9531 13.0798C12.3231 12.9198 12.7631 13.0098 13.0431 13.2898C13.2231 13.4798 13.3331 13.7398 13.3331 13.9998C13.3331 14.2598 13.2231 14.5198 13.0431 14.7098ZM16.5431 18.2098C16.3531 18.3898 16.0931 18.4998 15.8331 18.4998C15.5731 18.4998 15.3131 18.3898 15.1231 18.2098C14.9431 18.0198 14.8331 17.7598 14.8331 17.4998C14.8331 17.2398 14.9431 16.9798 15.1231 16.7898C15.4931 16.4198 16.1731 16.4198 16.5431 16.7898C16.7231 16.9798 16.8331 17.2398 16.8331 17.4998C16.8331 17.7598 16.7231 18.0198 16.5431 18.2098ZM16.5431 14.7098C16.4931 14.7498 16.4431 14.7898 16.3931 14.8298C16.3331 14.8698 16.2731 14.8998 16.2131 14.9198C16.1531 14.9498 16.0931 14.9698 16.0331 14.9798C15.9631 14.9898 15.8931 14.9998 15.8331 14.9998C15.5731 14.9998 15.3131 14.8898 15.1231 14.7098C14.9431 14.5198 14.8331 14.2598 14.8331 13.9998C14.8331 13.7398 14.9431 13.4798 15.1231 13.2898C15.2231 13.1998 15.3231 13.1298 15.4531 13.0798C15.6331 12.9998 15.8331 12.9798 16.0331 13.0198C16.0931 13.0298 16.1531 13.0498 16.2131 13.0798C16.2731 13.0998 16.3331 13.1298 16.3931 13.1698C16.4431 13.2098 16.4931 13.2498 16.5431 13.2898C16.7231 13.4798 16.8331 13.7398 16.8331 13.9998C16.8331 14.2598 16.7231 14.5198 16.5431 14.7098Z"
                        fill="#8C8C8C"
                      />
                    </svg>
                  </a>
                  {/* {showcalendar && ( */}
                  {showcalendar && (
                    <div className="cal set-custom-calendar-div">
                      <DateRange
                        editableDateInputs={true}
                        onChange={(item) => {
                          formatDates([item.selection]);
                        }}
                        moveRangeOnFirstSelection={false}
                        ranges={state}
                      />
                    </div>
                  )}
                </div>
              </div>
            ) : null}
          </div>

          <div className="bottom-cards">
            <div className="single-card">
              <div className="twice-set-items">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M18.6894 15.4595L6.58083 15.4595L6.58083 13.5856L18.6894 13.5856L18.6894 15.4595Z"
                    fill="#fff"
                  />
                  <path
                    d="M20.2041 9.11768L8.09548 9.11767L8.81623 7.2438L20.2041 7.2438L20.2041 9.11768Z"
                    fill="#fff"
                  />
                  <path
                    d="M6.07713 5.8739L3.12205 5.8739L3.12205 4.00002L6.07713 4.00002L6.07713 5.8739Z"
                    fill="#fff"
                  />
                  <path
                    d="M16.9152 14.972L18.7253 7.24332L20.2035 7.24332L20.2035 9.11719L18.7253 15.4569L16.9152 14.972Z"
                    fill="#fff"
                  />
                  <path
                    d="M8.37918 15.0078L7.00974 8.50446L5.19964 8.98945L6.56908 15.4928L8.37918 15.0078Z"
                    fill="#fff"
                  />
                  <path
                    d="M8.37832 15.0085L6.04782 4.02005L4.23772 4.50505L6.56822 15.4935L8.37832 15.0085Z"
                    fill="#fff"
                  />
                  <mask id="path-7-inside-1_5294_1203" fill="white">
                    <ellipse
                      cx="9.82407"
                      cy="18.3785"
                      rx="1.58565"
                      ry="1.62163"
                    />
                  </mask>
                  <path
                    d="M9.78277 18.3785C9.78277 18.3827 9.78237 18.3851 9.78218 18.3861C9.78197 18.3871 9.78176 18.3877 9.78167 18.3879C9.78138 18.3886 9.78118 18.3885 9.78203 18.3877C9.78291 18.3868 9.78678 18.3831 9.79536 18.3794C9.79973 18.3775 9.80483 18.3758 9.81037 18.3747C9.81603 18.3735 9.82081 18.3731 9.82407 18.3731V21.627C11.6326 21.627 13.0367 20.138 13.0367 18.3785H9.78277ZM9.82407 18.3731C9.82732 18.3731 9.83211 18.3735 9.83776 18.3747C9.8433 18.3758 9.8484 18.3775 9.85277 18.3794C9.86135 18.3831 9.86523 18.3868 9.8661 18.3877C9.86695 18.3885 9.86676 18.3886 9.86646 18.3879C9.86637 18.3877 9.86617 18.3871 9.86595 18.3861C9.86576 18.3851 9.86536 18.3827 9.86536 18.3785H6.61146C6.61146 20.138 8.01558 21.627 9.82407 21.627V18.3731ZM9.86536 18.3785C9.86536 18.3742 9.86576 18.3718 9.86595 18.3709C9.86617 18.3698 9.86637 18.3693 9.86646 18.369C9.86676 18.3683 9.86695 18.3684 9.8661 18.3693C9.86523 18.3701 9.86135 18.3738 9.85277 18.3775C9.8484 18.3794 9.8433 18.3811 9.83776 18.3822C9.83211 18.3834 9.82732 18.3838 9.82407 18.3838V15.1299C8.01558 15.1299 6.61146 16.6189 6.61146 18.3785H9.86536ZM9.82407 18.3838C9.82081 18.3838 9.81603 18.3834 9.81037 18.3822C9.80483 18.3811 9.79973 18.3794 9.79536 18.3775C9.78678 18.3738 9.78291 18.3701 9.78203 18.3693C9.78118 18.3684 9.78138 18.3683 9.78167 18.369C9.78176 18.3693 9.78197 18.3698 9.78218 18.3709C9.78237 18.3718 9.78277 18.3742 9.78277 18.3785H13.0367C13.0367 16.6189 11.6326 15.1299 9.82407 15.1299V18.3838Z"
                    fill="#fff"
                    mask="url(#path-7-inside-1_5294_1203)"
                  />
                  <mask id="path-9-inside-2_5294_1203" fill="white">
                    <ellipse
                      cx="15.4461"
                      cy="18.378"
                      rx="1.58565"
                      ry="1.62163"
                    />
                  </mask>
                  <path
                    d="M15.4048 18.378C15.4048 18.3822 15.4044 18.3846 15.4042 18.3856C15.404 18.3866 15.4038 18.3872 15.4037 18.3874C15.4034 18.3881 15.4033 18.3881 15.4041 18.3872C15.405 18.3863 15.4088 18.3826 15.4174 18.3789C15.4218 18.377 15.4269 18.3754 15.4324 18.3742C15.4381 18.373 15.4429 18.3726 15.4461 18.3726V21.6265C17.2546 21.6265 18.6587 20.1375 18.6587 18.378H15.4048ZM15.4461 18.3726C15.4494 18.3726 15.4542 18.373 15.4598 18.3742C15.4654 18.3754 15.4705 18.377 15.4748 18.3789C15.4834 18.3826 15.4873 18.3863 15.4882 18.3872C15.489 18.3881 15.4888 18.3881 15.4885 18.3874C15.4884 18.3872 15.4882 18.3866 15.488 18.3856C15.4878 18.3846 15.4874 18.3822 15.4874 18.378H12.2335C12.2335 20.1375 13.6377 21.6265 15.4461 21.6265V18.3726ZM15.4874 18.378C15.4874 18.3737 15.4878 18.3713 15.488 18.3704C15.4882 18.3693 15.4884 18.3688 15.4885 18.3686C15.4888 18.3678 15.489 18.3679 15.4882 18.3688C15.4873 18.3697 15.4834 18.3733 15.4748 18.377C15.4705 18.3789 15.4654 18.3806 15.4598 18.3817C15.4542 18.3829 15.4494 18.3833 15.4461 18.3833V15.1294C13.6377 15.1294 12.2335 16.6184 12.2335 18.378H15.4874ZM15.4461 18.3833C15.4429 18.3833 15.4381 18.3829 15.4324 18.3817C15.4269 18.3806 15.4218 18.3789 15.4174 18.377C15.4088 18.3733 15.405 18.3697 15.4041 18.3688C15.4033 18.3679 15.4034 18.3678 15.4037 18.3686C15.4038 18.3688 15.404 18.3693 15.4042 18.3704C15.4044 18.3713 15.4048 18.3737 15.4048 18.378H18.6587C18.6587 16.6184 17.2546 15.1294 15.4461 15.1294V18.3833Z"
                    fill="#fff"
                    mask="url(#path-9-inside-2_5294_1203)"
                  />
                </svg>
                <div className="inner-text">
                  <p>No. of Purchases</p>
                  <h6>
                    {statsData?.stats?.length > 0
                      ? statsData?.stats[0]?.purchases || 0
                      : 0}{" "}
                    <span className={pc > 0 ? "green-text" : "red-text"}>
                      {pc ? pc?.toFixed(1) + "% " : ""}
                    </span>
                  </h6>
                </div>
              </div>
              <div className="bottom-text">
                {/* <p className="uni-text">
                    <span></span>
                    {tokenNftStats
                      ? tokenNftStats?.tokensPurchasesCount?.toFixed(4)
                      : 0}{" "}
                    Token
                  </p> */}
                {/* <p className="uni-text">
                    <span></span>
                    {tokenNftStats
                      ? parseInt(
                          tokenNftStats?.nftPurchasesCount?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    NFT
                  </p> */}
              </div>
            </div>
            <div className="single-card" style={{ overflow: "hidden" }}>
              <div className="twice-set-items">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.8766 15.3805C7.40598 13.4273 6.21685 9.10163 8.22063 5.71872C10.2244 2.33582 14.6623 1.17675 18.1329 3.12987C21.6036 5.08299 22.7927 9.40869 20.7889 12.7916C18.7852 16.1745 14.3473 17.3336 10.8766 15.3805ZM6.28307 4.62835C3.66148 9.05429 5.21725 14.7137 9.75798 17.269C14.2987 19.8243 20.1049 18.3079 22.7265 13.882C25.3481 9.45603 23.7923 3.79661 19.2516 1.24129C14.7109 -1.31402 8.90466 0.202417 6.28307 4.62835Z"
                    fill="#fff"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.87667 20.2024C1.78508 17.7169 1.34605 13.2591 3.89607 10.2456L2.17013 8.85803C-1.16612 12.8006 -0.591727 18.6328 3.45307 21.8847C7.49786 25.1366 13.4814 24.5768 16.8176 20.6342L15.0917 19.2466C12.5417 22.26 7.96825 22.688 4.87667 20.2024Z"
                    fill="#fff"
                  />
                  <path
                    d="M10.7869 9.54895L14.5013 13.1694L18.2156 9.54895L14.5013 5.92846L10.7869 9.54895Z"
                    fill="#fff"
                  />
                </svg>
                <div className="inner-text">
                  {/* {selectedItem && selectedItem?.text} */}
                  <p>Total {project} Purchased</p>
                  <h6>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                          (statsData?.stats?.length > 0
                            ? statsData.stats[0]?.totalNftSum
                            : 0
                          )?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}
                    &nbsp;
                    {selectedItem && selectedItem?.text}
                    <span className={dpc > 0 ? "green-text" : "red-text"}>
                      {dpc ? dpc?.toFixed(1) + "% " : ""}
                    </span>
                  </h6>
                </div>
              </div>
              {selectedItem?.text == "MINER" ? (
                <div className="bottom-text">
                  {statsData?.nftQuantity?.length > 0 ? (
                    <>
                      <p className="uni-text">
                        <span></span>
                        {statsData?.nftQuantity[0]?.summedArray[0]} Mini
                      </p>
                      <p className="uni-text">
                        <span></span>
                        {statsData?.nftQuantity[0]?.summedArray[1]} Standard
                      </p>
                      <p className="uni-text">
                        <span></span>
                        {statsData?.nftQuantity[0]?.summedArray[2]} Mega
                      </p>
                    </>
                  ) : (
                    <>
                      <p className="uni-text">
                        <span></span>0 Mini
                      </p>
                      <p className="uni-text">
                        <span></span>0 Standard
                      </p>
                      <p className="uni-text">
                        <span></span>0 Mega
                      </p>
                    </>
                  )}
                </div>
              ) : null}
            </div>
            <div className="single-card">
              <div className="twice-set-items">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M14 11H10C9.46957 11 8.96086 10.7893 8.58579 10.4142C8.21071 10.0391 8 9.53043 8 9C8 8.46957 8.21071 7.96086 8.58579 7.58579C8.96086 7.21071 9.46957 7 10 7H15C15.2652 7 15.5196 7.10536 15.7071 7.29289C15.8946 7.48043 16 7.73478 16 8C16 8.26522 16.1054 8.51957 16.2929 8.70711C16.4804 8.89464 16.7348 9 17 9C17.2652 9 17.5196 8.89464 17.7071 8.70711C17.8946 8.51957 18 8.26522 18 8C18 7.20435 17.6839 6.44129 17.1213 5.87868C16.5587 5.31607 15.7956 5 15 5H13V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2C11.7348 2 11.4804 2.10536 11.2929 2.29289C11.1054 2.48043 11 2.73478 11 3V5H10C8.93913 5 7.92172 5.42143 7.17157 6.17157C6.42143 6.92172 6 7.93913 6 9C6 10.0609 6.42143 11.0783 7.17157 11.8284C7.92172 12.5786 8.93913 13 10 13H14C14.5304 13 15.0391 13.2107 15.4142 13.5858C15.7893 13.9609 16 14.4696 16 15C16 15.5304 15.7893 16.0391 15.4142 16.4142C15.0391 16.7893 14.5304 17 14 17H9C8.73478 17 8.48043 16.8946 8.29289 16.7071C8.10536 16.5196 8 16.2652 8 16C8 15.7348 7.89464 15.4804 7.70711 15.2929C7.51957 15.1054 7.26522 15 7 15C6.73478 15 6.48043 15.1054 6.29289 15.2929C6.10536 15.4804 6 15.7348 6 16C6 16.7956 6.31607 17.5587 6.87868 18.1213C7.44129 18.6839 8.20435 19 9 19H11V21C11 21.2652 11.1054 21.5196 11.2929 21.7071C11.4804 21.8946 11.7348 22 12 22C12.2652 22 12.5196 21.8946 12.7071 21.7071C12.8946 21.5196 13 21.2652 13 21V19H14C15.0609 19 16.0783 18.5786 16.8284 17.8284C17.5786 17.0783 18 16.0609 18 15C18 13.9391 17.5786 12.9217 16.8284 12.1716C16.0783 11.4214 15.0609 11 14 11Z"
                    fill="#fff"
                  />
                </svg>
                <div className="inner-text">
                  <p>Purchased Amount</p>
                  <h6 className="datahead">
                    {statsData?.stats?.length > 0
                      ? "~$" +
                        parseInt(
                          statsData?.stats[0]?.totalSaleConverted ||
                            0
                              // usdPrice *
                              //   (tokenNftStats?.purchasedAmount[0]
                              //     ?.totalPurchaseEth || 0) +
                              // btcPrice *
                              //   (tokenNftStats?.purchasedAmount[0]
                              //     ?.totalPurchaseWbtc || 0) +
                              // (tokenNftStats?.purchasedAmount[0]
                              //   ?.totalPurchaseUsdt || 0) +
                              // dopPrice *
                              //   (tokenNftStats?.purchasedAmount[0]
                              //     ?.totalPurchaseDopToken || 0) +
                              // (tokenNftStats?.purchasedAmount[0]
                              //   ?.totalPurchaseUsdc || 0) +
                              // pepePrice *
                              //   (tokenNftStats?.purchasedAmount[0]
                              //     ?.totalPurchasePepe || 0) +
                              // linkPrice *
                              //   (tokenNftStats?.purchasedAmount[0]
                              //     ?.totalPurchaseLink || 0) +
                              // uniPrice *
                              //   (tokenNftStats?.purchasedAmount[0]
                              //     ?.totalPurchaseUni || 0)
                              ?.toFixed(2)
                        ).toLocaleString("en-US")
                      : 0}{" "}
                    <span className={pmc > 0 ? "green-text" : "red-text"}>
                      {pmc ? pmc?.toFixed(1) + "% " : ""}
                    </span>
                  </h6>
                </div>
              </div>
              <div className="bottom-text">
                {/* {selectedItem?.text == "NODE" ? ( */}
                <p className="uni-text">
                  <span></span>
                  {statsData?.stats?.length > 0
                    ? parseFloat(
                        parseFloat(statsData?.stats[0]?.totalEth || 0)?.toFixed(
                          5
                        )
                      )?.toLocaleString("en-US")
                    : 0}{" "}
                  ETH
                </p>
                <p className="uni-text">
                  <span></span>
                  {statsData?.stats?.length > 0
                    ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.totalUsdt || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                    : 0}{" "}
                  USDT
                </p>
                <p className="uni-text">
                  <span></span>
                  {statsData?.stats?.length > 0
                    ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.totalUsdc || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                    : 0}{" "}
                  USDC
                </p>
                {/* <p className="uni-text">
                  <span></span>
                  {statsData?.stats?.length > 0
                    ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.totalGems || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                    : 0}{" "}
                  GEMS
                </p> */}
                {/* ) : null} */}
              </div>
              <div class="dropdown cardinsidedrop">
                <button
                  class=""
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="7"
                    viewBox="0 0 13 7"
                    fill="none"
                  >
                    <path
                      d="M0.601562 0.5L0.601563 3.0462L6.80156 6.5L6.80156 3.9538L0.601562 0.5Z"
                      fill="#fff"
                    />
                    <path
                      d="M13 0.5L13 3.0462L6.8 6.5L6.8 3.9538L13 0.5Z"
                      fill="#fff"
                    />
                  </svg>
                </button>
                <ul class="dropdown-menu newmenu">
                  <div className="text">
                    <p>ETH</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(statsData?.stats[0]?.totalEth || 0)?.toFixed(
                          4
                        )
                      : 0}{" "}
                    ETH
                  </div>
                  <div className="text">
                    <p>USDT</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                          parseFloat(
                            statsData?.stats[0]?.totalUsdt || 0
                          )?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    USDT
                  </div>
                  <div className="text">
                    <p>USDC</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                          parseFloat(
                            statsData?.stats[0]?.totalUsdc || 0
                          )?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    USDC
                  </div>
                  <div className="text">
                    <p>DOP</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                          parseFloat(
                            statsData?.stats[0]?.totalDopToken || 0
                          )?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    DOP
                  </div>
                  <div className="text">
                    <p>WBTC</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                          parseFloat(
                            statsData?.stats[0]?.totalWbtc || 0
                          )?.toFixed(6)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    WBTC
                  </div>
                  <div className="text">
                    <p>PEPE</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                          parseFloat(
                            statsData?.stats[0]?.totalPepe || 0
                          )?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    PEPE
                  </div>{" "}
                  <div className="text">
                    <p>LINK</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                          parseFloat(
                            statsData?.stats[0]?.totalLink || 0
                          )?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    LINK
                  </div>{" "}
                  <div className="text">
                    <p>UNI</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                          parseFloat(
                            statsData?.stats[0]?.totalUni || 0
                          )?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    UNI
                  </div>
                  <div className="text">
                    <p>TOMI</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                          parseFloat(
                            statsData?.stats[0]?.totalTomi || 0
                          )?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    TOMI
                  </div>
                  <div className="text">
                    <p>XEN</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                          parseFloat(
                            statsData?.stats[0]?.totalGems || 0
                          )?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    XEN
                  </div>
                </ul>
              </div>
            </div>

            {selectedItem?.text == "MINER" ? (
              <>
                <div className="single-card mobile-spec-height">
                  <div className="twice-set-items">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M19.4207 3L4.17833 3L4.17833 5.21398L19.4207 5.21398L19.4207 3Z"
                        fill="#fff"
                      />
                      <path
                        d="M8.26561 12.3667L3.41188 12.3667L3.41188 14.5807L8.26561 14.5807L8.26561 12.3667Z"
                        fill="#fff"
                      />
                      <path
                        d="M20.3575 12.3667L15.5038 12.3667L15.5038 14.5807L20.3575 14.5807L20.3575 12.3667Z"
                        fill="#fff"
                      />
                      <path
                        d="M20.3575 14.5811L20.3575 3.00024L18.1435 3.00024L18.1435 14.5811L20.3575 14.5811Z"
                        fill="#fff"
                      />
                      <path
                        d="M5.5407 14.5811L5.5407 3.00024L3.32672 3.00024L3.32672 14.5811L5.5407 14.5811Z"
                        fill="#fff"
                      />
                      <path
                        d="M5.96712 16.0669L5.96712 18.4898L11.8382 21.7764L11.8382 19.3535L5.96712 16.0669Z"
                        fill="#fff"
                      />
                      <path
                        d="M17.7218 16.0669L17.7218 18.4898L11.8507 21.7764L10.8358 20.2493L11.8507 19.3535L17.7218 16.0669Z"
                        fill="#fff"
                      />
                      <path
                        d="M12.9495 16.6082L12.9495 9.21653L10.7355 10.4513L10.7355 17.7358L12.9495 16.6082Z"
                        fill="#fff"
                      />
                    </svg>
                    <div className="inner-text">
                      <p>Total Mini Miners Purchased</p>
                      {usdPrice ? (
                        <h6 className="datahead">
                          {statsData?.nftAmount?.length > 0
                            ? "~$" +
                              parseInt(
                                statsData?.nftAmount[0]?.sumAmountArray[0]?.toFixed(
                                  2
                                ) || 0
                              ).toLocaleString("en-US")
                            : 0}{" "}
                          <span className={lec > 0 ? "green-text" : "red-text"}>
                            {lec ? lec.toFixed(1) + "% " : ""}
                          </span>
                        </h6>
                      ) : (
                        <h6 className="datahead">~$0.00 USD </h6>
                      )}
                    </div>
                  </div>
                  {/* <div className="bottom-text">
                <p className="uni-text">
                  <span></span>
                  {statsData?.stats?.length > 0
                    ? parseFloat(
                        statsData?.stats[0]?.netRevenueEth || 0
                      )?.toFixed(4)
                    : 0}{" "}
                  ETH
                </p>
                <p className="uni-text">
                  <span></span>
                  {statsData?.stats?.length > 0
                    ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueUsdt || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                    : 0}{" "}
                  USDT
                </p>
              </div> */}
                  {/* <div class="dropdown cardinsidedrop">
                <button
                  class=""
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="7"
                    viewBox="0 0 13 7"
                    fill="none"
                  >
                    <path
                      d="M0.601562 0.5L0.601563 3.0462L6.80156 6.5L6.80156 3.9538L0.601562 0.5Z"
                      fill="#fff"
                    />
                    <path
                      d="M13 0.5L13 3.0462L6.8 6.5L6.8 3.9538L13 0.5Z"
                      fill="#fff"
                    />
                  </svg>
                </button>
                <ul class="dropdown-menu newmenu">
                  <div className="text">
                    <p>ETH</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        statsData?.stats[0]?.netRevenueEth || 0
                      )?.toFixed(4)
                      : 0}{" "}
                    ETH
                  </div>
                  <div className="text">
                    <p>USDT</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueUsdt || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    USDT
                  </div>
                  <div className="text">
                    <p>USDC</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueUsdc || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    USDC
                  </div>
                  <div className="text">
                    <p>DOP</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueDopToken || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    DOP
                  </div>
                  <div className="text">
                    <p>WBTC</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueWbtc || 0
                        )?.toFixed(6)
                      )
                      : 0}{" "}
                    WBTC
                  </div>
                  <div className="text">
                    <p>PEPE</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.netRevenuePepe || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    PEPE
                  </div>{" "}
                  <div className="text">
                    <p>LINK</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueLink || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    LINK
                  </div>{" "}
                  <div className="text">
                    <p>UNI</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueUni || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    UNI
                  </div>
                  <div className="text">
                    <p>TOMI</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueTomi || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    TOMI
                  </div>
                  <div className="text">
                    <p>GEMS</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueGems || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    GEMS
                  </div>
                </ul>
              </div> */}
                </div>
                <div className="single-card mobile-spec-height">
                  <div className="twice-set-items">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M19.4207 3L4.17833 3L4.17833 5.21398L19.4207 5.21398L19.4207 3Z"
                        fill="#fff"
                      />
                      <path
                        d="M8.26561 12.3667L3.41188 12.3667L3.41188 14.5807L8.26561 14.5807L8.26561 12.3667Z"
                        fill="#fff"
                      />
                      <path
                        d="M20.3575 12.3667L15.5038 12.3667L15.5038 14.5807L20.3575 14.5807L20.3575 12.3667Z"
                        fill="#fff"
                      />
                      <path
                        d="M20.3575 14.5811L20.3575 3.00024L18.1435 3.00024L18.1435 14.5811L20.3575 14.5811Z"
                        fill="#fff"
                      />
                      <path
                        d="M5.5407 14.5811L5.5407 3.00024L3.32672 3.00024L3.32672 14.5811L5.5407 14.5811Z"
                        fill="#fff"
                      />
                      <path
                        d="M5.96712 16.0669L5.96712 18.4898L11.8382 21.7764L11.8382 19.3535L5.96712 16.0669Z"
                        fill="#fff"
                      />
                      <path
                        d="M17.7218 16.0669L17.7218 18.4898L11.8507 21.7764L10.8358 20.2493L11.8507 19.3535L17.7218 16.0669Z"
                        fill="#fff"
                      />
                      <path
                        d="M12.9495 16.6082L12.9495 9.21653L10.7355 10.4513L10.7355 17.7358L12.9495 16.6082Z"
                        fill="#fff"
                      />
                    </svg>
                    <div className="inner-text">
                      <p>Total Standard Miners Purchased</p>
                      {usdPrice ? (
                        <h6 className="datahead">
                          {statsData?.nftAmount?.length > 0
                            ? "~$" +
                              parseInt(
                                statsData?.nftAmount[0]?.sumAmountArray[1]?.toFixed(
                                  2
                                ) || 0
                              ).toLocaleString("en-US")
                            : 0}{" "}
                          <span className={lec > 0 ? "green-text" : "red-text"}>
                            {lec ? lec.toFixed(1) + "% " : ""}
                          </span>
                        </h6>
                      ) : (
                        <h6 className="datahead">~$0.00 USD </h6>
                      )}
                    </div>
                  </div>
                  {/* <div className="bottom-text">
                <p className="uni-text">
                  <span></span>
                  {statsData?.stats?.length > 0
                    ? parseFloat(
                        statsData?.stats[0]?.netRevenueEth || 0
                      )?.toFixed(4)
                    : 0}{" "}
                  ETH
                </p>
                <p className="uni-text">
                  <span></span>
                  {statsData?.stats?.length > 0
                    ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueUsdt || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                    : 0}{" "}
                  USDT
                </p>
              </div> */}
                  {/* <div class="dropdown cardinsidedrop">
                <button
                  class=""
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="7"
                    viewBox="0 0 13 7"
                    fill="none"
                  >
                    <path
                      d="M0.601562 0.5L0.601563 3.0462L6.80156 6.5L6.80156 3.9538L0.601562 0.5Z"
                      fill="#fff"
                    />
                    <path
                      d="M13 0.5L13 3.0462L6.8 6.5L6.8 3.9538L13 0.5Z"
                      fill="#fff"
                    />
                  </svg>
                </button>
                <ul class="dropdown-menu newmenu">
                  <div className="text">
                    <p>ETH</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        statsData?.stats[0]?.netRevenueEth || 0
                      )?.toFixed(4)
                      : 0}{" "}
                    ETH
                  </div>
                  <div className="text">
                    <p>USDT</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueUsdt || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    USDT
                  </div>
                  <div className="text">
                    <p>USDC</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueUsdc || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    USDC
                  </div>
                  <div className="text">
                    <p>DOP</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueDopToken || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    DOP
                  </div>
                  <div className="text">
                    <p>WBTC</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueWbtc || 0
                        )?.toFixed(6)
                      )
                      : 0}{" "}
                    WBTC
                  </div>
                  <div className="text">
                    <p>PEPE</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.netRevenuePepe || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    PEPE
                  </div>{" "}
                  <div className="text">
                    <p>LINK</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueLink || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    LINK
                  </div>{" "}
                  <div className="text">
                    <p>UNI</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueUni || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    UNI
                  </div>
                  <div className="text">
                    <p>TOMI</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueTomi || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    TOMI
                  </div>
                  <div className="text">
                    <p>GEMS</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueGems || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    GEMS
                  </div>
                </ul>
              </div> */}
                </div>
                <div className="single-card mobile-spec-height">
                  <div className="twice-set-items">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M19.4207 3L4.17833 3L4.17833 5.21398L19.4207 5.21398L19.4207 3Z"
                        fill="#fff"
                      />
                      <path
                        d="M8.26561 12.3667L3.41188 12.3667L3.41188 14.5807L8.26561 14.5807L8.26561 12.3667Z"
                        fill="#fff"
                      />
                      <path
                        d="M20.3575 12.3667L15.5038 12.3667L15.5038 14.5807L20.3575 14.5807L20.3575 12.3667Z"
                        fill="#fff"
                      />
                      <path
                        d="M20.3575 14.5811L20.3575 3.00024L18.1435 3.00024L18.1435 14.5811L20.3575 14.5811Z"
                        fill="#fff"
                      />
                      <path
                        d="M5.5407 14.5811L5.5407 3.00024L3.32672 3.00024L3.32672 14.5811L5.5407 14.5811Z"
                        fill="#fff"
                      />
                      <path
                        d="M5.96712 16.0669L5.96712 18.4898L11.8382 21.7764L11.8382 19.3535L5.96712 16.0669Z"
                        fill="#fff"
                      />
                      <path
                        d="M17.7218 16.0669L17.7218 18.4898L11.8507 21.7764L10.8358 20.2493L11.8507 19.3535L17.7218 16.0669Z"
                        fill="#fff"
                      />
                      <path
                        d="M12.9495 16.6082L12.9495 9.21653L10.7355 10.4513L10.7355 17.7358L12.9495 16.6082Z"
                        fill="#fff"
                      />
                    </svg>
                    <div className="inner-text">
                      <p>Total Mega Miners Purchased</p>
                      {usdPrice ? (
                        <h6 className="datahead">
                          {statsData?.nftAmount?.length > 0
                            ? "~$" +
                              parseInt(
                                statsData?.nftAmount[0]?.sumAmountArray[2]?.toFixed(
                                  2
                                ) || 0
                              ).toLocaleString("en-US")
                            : 0}{" "}
                          <span className={lec > 0 ? "green-text" : "red-text"}>
                            {lec ? lec.toFixed(1) + "% " : ""}
                          </span>
                        </h6>
                      ) : (
                        <h6 className="datahead">~$0.00 USD </h6>
                      )}
                    </div>
                  </div>
                  {/* <div className="bottom-text">
                <p className="uni-text">
                  <span></span>
                  {statsData?.stats?.length > 0
                    ? parseFloat(
                        statsData?.stats[0]?.netRevenueEth || 0
                      )?.toFixed(4)
                    : 0}{" "}
                  ETH
                </p>
                <p className="uni-text">
                  <span></span>
                  {statsData?.stats?.length > 0
                    ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueUsdt || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                    : 0}{" "}
                  USDT
                </p>
              </div> */}
                  {/* <div class="dropdown cardinsidedrop">
                <button
                  class=""
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="7"
                    viewBox="0 0 13 7"
                    fill="none"
                  >
                    <path
                      d="M0.601562 0.5L0.601563 3.0462L6.80156 6.5L6.80156 3.9538L0.601562 0.5Z"
                      fill="#fff"
                    />
                    <path
                      d="M13 0.5L13 3.0462L6.8 6.5L6.8 3.9538L13 0.5Z"
                      fill="#fff"
                    />
                  </svg>
                </button>
                <ul class="dropdown-menu newmenu">
                  <div className="text">
                    <p>ETH</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        statsData?.stats[0]?.netRevenueEth || 0
                      )?.toFixed(4)
                      : 0}{" "}
                    ETH
                  </div>
                  <div className="text">
                    <p>USDT</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueUsdt || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    USDT
                  </div>
                  <div className="text">
                    <p>USDC</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueUsdc || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    USDC
                  </div>
                  <div className="text">
                    <p>DOP</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueDopToken || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    DOP
                  </div>
                  <div className="text">
                    <p>WBTC</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueWbtc || 0
                        )?.toFixed(6)
                      )
                      : 0}{" "}
                    WBTC
                  </div>
                  <div className="text">
                    <p>PEPE</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.netRevenuePepe || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    PEPE
                  </div>{" "}
                  <div className="text">
                    <p>LINK</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueLink || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    LINK
                  </div>{" "}
                  <div className="text">
                    <p>UNI</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueUni || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    UNI
                  </div>
                  <div className="text">
                    <p>TOMI</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueTomi || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    TOMI
                  </div>
                  <div className="text">
                    <p>GEMS</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueGems || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    GEMS
                  </div>
                </ul>
              </div> */}
                </div>
                <div className="single-card mobile-spec-height">
                  <div className="twice-set-items">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M21 21.0002L21 18.0051L14.1869 13.9423L14.1869 16.9375L21 21.0002Z"
                        fill="#fff"
                      />
                      <path
                        d="M3 21.0002L3 18.0051L9.81312 13.9423L9.81312 16.9375L3 21.0002Z"
                        fill="#fff"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.0245 10.6326C13.3871 10.6326 14.4917 9.45592 14.4917 8.0044C14.4917 6.55288 13.3871 5.37619 12.0245 5.37619C10.6619 5.37619 9.55725 6.55288 9.55725 8.0044C9.55725 9.45592 10.6619 10.6326 12.0245 10.6326ZM12.0245 13.0088C14.619 13.0088 16.7223 10.7683 16.7223 8.0044C16.7223 5.24055 14.619 3 12.0245 3C9.42991 3 7.32661 5.24055 7.32661 8.0044C7.32661 10.7683 9.42991 13.0088 12.0245 13.0088Z"
                        fill="#fff"
                      />
                    </svg>
                    <div className="inner-text">
                      <p>Leader’s Earnings</p>
                      {usdPrice ? (
                        <h6 className="datahead">
                          {statsData?.stats?.length > 0
                            ? "~$" +
                              parseInt(
                                statsData?.stats[0]?.myEarningConverted?.toFixed(
                                  2
                                )
                              ).toLocaleString("en-US")
                            : 0}{" "}
                          <span className={lec > 0 ? "green-text" : "red-text"}>
                            {lec ? lec.toFixed(1) + "% " : ""}
                          </span>
                        </h6>
                      ) : (
                        <h6 className="datahead">~$0.00 USD </h6>
                      )}
                    </div>
                  </div>
                  {/* <div className="bottom-text">
                <p className="uni-text">
                  <span></span>
                  {statsData?.stats?.length > 0
                    ? parseFloat(
                        statsData?.stats[0]?.netRevenueEth || 0
                      )?.toFixed(4)
                    : 0}{" "}
                  ETH
                </p>
                <p className="uni-text">
                  <span></span>
                  {statsData?.stats?.length > 0
                    ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueUsdt || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                    : 0}{" "}
                  USDT
                </p>
              </div> */}
                  {/* <div class="dropdown cardinsidedrop">
                <button
                  class=""
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="7"
                    viewBox="0 0 13 7"
                    fill="none"
                  >
                    <path
                      d="M0.601562 0.5L0.601563 3.0462L6.80156 6.5L6.80156 3.9538L0.601562 0.5Z"
                      fill="#fff"
                    />
                    <path
                      d="M13 0.5L13 3.0462L6.8 6.5L6.8 3.9538L13 0.5Z"
                      fill="#fff"
                    />
                  </svg>
                </button>
                <ul class="dropdown-menu newmenu">
                  <div className="text">
                    <p>ETH</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        statsData?.stats[0]?.netRevenueEth || 0
                      )?.toFixed(4)
                      : 0}{" "}
                    ETH
                  </div>
                  <div className="text">
                    <p>USDT</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueUsdt || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    USDT
                  </div>
                  <div className="text">
                    <p>USDC</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueUsdc || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    USDC
                  </div>
                  <div className="text">
                    <p>DOP</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueDopToken || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    DOP
                  </div>
                  <div className="text">
                    <p>WBTC</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueWbtc || 0
                        )?.toFixed(6)
                      )
                      : 0}{" "}
                    WBTC
                  </div>
                  <div className="text">
                    <p>PEPE</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.netRevenuePepe || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    PEPE
                  </div>{" "}
                  <div className="text">
                    <p>LINK</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueLink || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    LINK
                  </div>{" "}
                  <div className="text">
                    <p>UNI</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueUni || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    UNI
                  </div>
                  <div className="text">
                    <p>TOMI</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueTomi || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    TOMI
                  </div>
                  <div className="text">
                    <p>GEMS</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                        parseFloat(
                          statsData?.stats[0]?.netRevenueGems || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                      : 0}{" "}
                    GEMS
                  </div>
                </ul>
              </div> */}
                </div>

                <div className="single-card">
                  <div className="inner-parent">
                    <div className="twice-set-items">
                      <div className="left-img">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="27"
                          height="24"
                          viewBox="0 0 27 24"
                          fill="none"
                        >
                          <path
                            d="M7.53908 3L3 7.88639V11.0557L13.0022 21L23 11.061V9.78122H10.7877L11.634 12.4235H17.3161L13.0013 16.7153L6.14759 9.89853L9.62764 6.15687H16.375L17.8621 7.75752H22.4388V7.28292L18.46 3H7.53908Z"
                            fill="#fff"
                          />
                        </svg>
                      </div>
                      <div className="right-stats">
                        <p className="mt-0">Xen Net Revenue</p>
                        {statsData?.stats?.length > 0 ? (
                          <h6>
                            ~$
                            {parseFloat(
                              parseFloat(
                                (statsData?.stats[0]?.totalSaleConverted || 0) *
                                  0.05
                              )?.toFixed(2)
                            )?.toLocaleString() || 0}{" "}
                            {/* <span className="green">+0.8%</span> */}
                          </h6>
                        ) : (
                          <h6>~$ 0</h6>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <div className="bottom-text">
                <p className="uni-text">
                  <span></span>
                  1.3M ETH
                </p>
                <p className="uni-text">
                  <span></span>
                  521.521 USDT
                </p>
              </div> */}
                </div>
                <div className="single-card">
                  <div className="inner-parent">
                    <div className="twice-set-items">
                      <div className="left-img">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="24"
                          viewBox="0 0 25 24"
                          fill="none"
                        >
                          <path
                            d="M17.6279 20.9358L17.6279 18.1822L10.9556 14.4471L10.9556 17.2007L17.6279 20.9358Z"
                            fill="#fff"
                          />
                          <path
                            d="M0 20.9358L8.42534e-07 18.1822L6.67229 14.4471L6.67229 17.2007L0 20.9358Z"
                            fill="#fff"
                          />
                          <path
                            d="M24.0968 20.3503L24.0968 17.5968L17.9149 14.1565L17.9149 16.9101L24.0968 20.3503Z"
                            fill="#fff"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.7581 4.89424C7.35708 4.89424 6.22133 6.02999 6.22133 7.43101C6.22133 8.83203 7.35708 9.96778 8.7581 9.96778C10.1591 9.96778 11.2949 8.83203 11.2949 7.43101C11.2949 6.02999 10.1591 4.89424 8.7581 4.89424ZM4.0368 7.43101C4.0368 4.82351 6.1506 2.70972 8.7581 2.70972C11.3656 2.70972 13.4794 4.82351 13.4794 7.43101C13.4794 10.0385 11.3656 12.1523 8.7581 12.1523C6.1506 12.1523 4.0368 10.0385 4.0368 7.43101Z"
                            fill="#fff"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M18.5529 7.43101C18.5529 6.02999 17.4171 4.89424 16.0161 4.89424V2.70972C18.6236 2.70972 20.7374 4.82351 20.7374 7.43101C20.7374 10.0385 18.6236 12.1523 16.0161 12.1523V9.96778C17.4171 9.96778 18.5529 8.83203 18.5529 7.43101Z"
                            fill="#fff"
                          />
                        </svg>
                      </div>
                      <div className="right-stats">
                        <p className="mt-0">Leaders/Active Leaders</p>
                        <h6>
                          {totalleader ? totalleader : 0} /{" "}
                          {activeleader ? activeleader : 0}
                          {/* <span className="green">+0.8%</span> */}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : null}

            {project == "MINER" ? (
              <>
                <div className="single-card">
                  <div className="inner-parent">
                    <div className="twice-set-items">
                      <div className="left-img">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M11.677 22.8941C11.6201 22.8941 11.5632 22.887 11.508 22.8719C11.4182 22.8487 2.56165 20.4227 2.56165 12.1593V4.8857C2.56165 4.60645 2.73595 4.35656 2.9974 4.25963L11.4458 1.14707C11.5952 1.09193 11.7588 1.09193 11.9082 1.14707L20.3566 4.25963C20.6181 4.35567 20.7924 4.60557 20.7924 4.8857V12.1593C20.7924 20.4227 11.9358 22.8487 11.846 22.8719C11.7908 22.887 11.7339 22.8941 11.677 22.8941ZM3.8956 5.3508V12.1593C3.8956 18.8807 10.4925 21.1759 11.677 21.5334C12.8616 21.1759 19.4584 18.8807 19.4584 12.1593V5.3508L11.677 2.48369L3.8956 5.3508Z"
                            fill="#fff"
                          />
                          <path
                            d="M11.6774 11.2639C10.2321 11.2639 9.05481 10.0879 9.05481 8.64137C9.05481 7.19487 10.2321 6.0188 11.6774 6.0188C13.1227 6.0188 14.2999 7.19487 14.2999 8.64137C14.2999 10.0879 13.1227 11.2639 11.6774 11.2639ZM11.6774 7.76718C11.196 7.76718 10.8032 8.15881 10.8032 8.64137C10.8032 9.12392 11.196 9.51555 11.6774 9.51555C12.1588 9.51555 12.5516 9.12392 12.5516 8.64137C12.5516 8.15881 12.1588 7.76718 11.6774 7.76718Z"
                            fill="#fff"
                          />
                          <path
                            d="M15.7564 17.093H7.59733C7.11478 17.093 6.72314 16.7014 6.72314 16.2188V15.0533C6.72314 13.2851 8.16031 11.8479 9.9285 11.8479H13.4253C15.1935 11.8479 16.6306 13.2851 16.6306 15.0533V16.2188C16.6306 16.7014 16.239 17.093 15.7564 17.093ZM8.47152 15.3447H14.8822V15.0533C14.8822 14.2502 14.2283 13.5963 13.4253 13.5963H9.9285C9.12542 13.5963 8.47152 14.2502 8.47152 15.0533V15.3447Z"
                            fill="#fff"
                          />
                        </svg>
                      </div>
                      <div className="right-stats">
                        <p className="mt-0">Gems Protect Transactoins</p>
                        <h6>
                          {statsData?.protectedStats?.length > 0
                            ? parseInt(
                                statsData?.protectedStats[0]?.purchases || 0
                              )?.toLocaleString()
                            : 0}{" "}
                          {protTrxCh > 0 ? (
                            <span className="green">
                              +{parseFloat(protTrxCh)?.toFixed(2)}%
                            </span>
                          ) : protTrxCh < 0 ? (
                            <span className="red">
                              {parseFloat(protTrxCh)?.toFixed(2)}%
                            </span>
                          ) : (
                            <span className="">{parseInt(protTrxCh)}%</span>
                          )}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="single-card">
                  <div className="inner-parent">
                    <div className="twice-set-items">
                      <div className="left-img">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_6684_7428)">
                            <path
                              d="M19.4622 15.1138L17.4776 17.0984L16.7142 16.3351C16.4613 16.0821 16.0512 16.0821 15.7983 16.3351C15.5453 16.588 15.5453 16.9981 15.7983 17.251L17.0196 18.4723C17.146 18.5988 17.3118 18.662 17.4775 18.662C17.6432 18.662 17.8091 18.5988 17.9355 18.4723L20.3781 16.0297C20.631 15.7768 20.631 15.3667 20.3781 15.1138C20.1253 14.8608 19.7152 14.8608 19.4622 15.1138Z"
                              fill="#fff"
                            />
                            <path
                              d="M10.3873 14.9107C10.2873 14.8754 10.1854 14.8386 10.0834 14.8007V12.9742C10.2708 13.0388 10.3678 13.1328 10.3806 13.1458C10.5768 13.3676 10.9156 13.3899 11.1393 13.195C11.364 12.9991 11.3875 12.6582 11.1916 12.4335C11.0072 12.2219 10.6248 11.9564 10.0834 11.8658V11.5683C10.0834 11.2702 9.84174 11.0286 9.54364 11.0286C9.24553 11.0286 9.0039 11.2702 9.0039 11.5683V11.9257C8.96607 11.9355 8.92795 11.9461 8.88939 11.9577C8.23687 12.1543 7.74955 12.7115 7.61755 13.4118C7.49652 14.054 7.70477 14.6752 8.16091 15.033C8.37927 15.2043 8.64582 15.3613 9.0039 15.5248V17.8959C8.74271 17.8612 8.54737 17.7758 8.24131 17.5756C7.99183 17.4124 7.65736 17.4823 7.49419 17.7318C7.33101 17.9813 7.40092 18.3158 7.65041 18.4789C8.17965 18.8251 8.55173 18.9444 9.0039 18.9818V19.3405C9.0039 19.6386 9.24553 19.8803 9.54364 19.8803C9.84174 19.8803 10.0834 19.6386 10.0834 19.3405V18.9314C10.438 18.8446 10.7606 18.6728 11.0337 18.4218C11.399 18.0862 11.6455 17.6315 11.7279 17.1415C11.8973 16.1341 11.3711 15.2584 10.3873 14.9107ZM8.82712 14.1837C8.69137 14.0772 8.63295 13.8527 8.67837 13.6118C8.71266 13.4299 8.81534 13.2188 9.0039 13.087V14.3061C8.93995 14.2661 8.88023 14.2253 8.82712 14.1837ZM10.6634 16.9626C10.6108 17.2751 10.4143 17.6049 10.0834 17.7834V15.9497C10.7162 16.2034 10.7009 16.7393 10.6634 16.9626Z"
                              fill="#fff"
                            />
                            <path
                              d="M22.4061 12.2592C21.5877 12.2592 20.8519 11.8044 20.4858 11.0724L20.3947 10.8901C20.285 10.6706 20.0607 10.532 19.8154 10.532H16.3611C16.1157 10.532 15.8915 10.6706 15.7817 10.8901L15.6906 11.0724C15.6555 11.1425 15.617 11.2102 15.5754 11.2751C14.6912 10.0827 13.7095 9.02159 12.8204 8.10904V5.99267C13.6799 4.77925 14.1158 3.44584 14.1158 2.02576V1.59397C14.1158 1.23628 13.8258 0.946289 13.4681 0.946289H13.0363C11.8368 0.946289 10.2722 1.72317 9.58197 2.10116C8.89176 1.72317 7.32716 0.946289 6.12765 0.946289H5.69586C5.33817 0.946289 5.04818 1.23628 5.04818 1.59397V2.02576C5.04818 3.44579 5.48402 4.77925 6.34355 5.99271V8.1093C3.64339 10.885 0.946167 14.2282 0.946167 18.0884L0.94621 18.1348C0.952255 20.8472 3.19545 23.054 5.94677 23.054H13.2172C14.2415 23.054 15.2388 22.7406 16.0758 22.1637C16.6315 22.5385 17.2447 22.8294 17.9021 23.0266C17.9628 23.0448 18.0255 23.054 18.0882 23.054C18.151 23.054 18.2136 23.0448 18.2744 23.0266C19.6662 22.6091 20.8605 21.7721 21.7279 20.6063C22.5954 19.4404 23.0538 18.056 23.0538 16.6029V12.9069C23.0538 12.5492 22.7638 12.2592 22.4061 12.2592ZM7.63892 6.43003H11.525V7.7254H7.63892V6.43003ZM9.24971 3.40214C9.45412 3.52429 9.7094 3.52429 9.91398 3.40227C10.4159 3.10295 11.8417 2.36092 12.8159 2.25444C12.7748 3.28521 12.454 4.23226 11.8399 5.13466H7.3241C6.70996 4.23221 6.38914 3.28517 6.34808 2.25444C7.3222 2.36092 8.74806 3.10295 9.24971 3.40214ZM5.94677 21.7586C3.90816 21.7586 2.24603 20.1317 2.24158 18.1325L2.24154 18.0884C2.24154 14.6919 4.74873 11.6073 7.26391 9.02077H11.9002C12.7699 9.91371 13.7286 10.9507 14.5771 12.1036C14.3259 12.2049 14.0531 12.2592 13.7703 12.2592C13.4126 12.2592 13.1227 12.5492 13.1227 12.9069V16.6029C13.1227 18.056 13.5811 19.4404 14.4486 20.6063C14.6287 20.8483 14.823 21.0759 15.0302 21.2888C14.4787 21.5942 13.8552 21.7586 13.2172 21.7586H5.94677ZM21.7585 16.6029C21.7585 18.9456 20.2916 20.9806 18.0882 21.7265C15.8849 20.9806 14.418 18.9456 14.418 16.6029V13.4942C15.3982 13.3092 16.2504 12.7083 16.7551 11.8274H19.4214C19.9261 12.7083 20.7783 13.3092 21.7585 13.4942V16.6029Z"
                              fill="#fff"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_6684_7428">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div className="right-stats">
                        <p className="mt-0">Protected Amount</p>
                        <h6>
                          {statsData?.protectedStats?.length > 0
                            ? "~$" +
                              formatTokenValue(
                                statsData?.protectedStats[0]
                                  ?.totalSaleConverted * 0.75 || 0
                              )
                            : 0}{" "}
                          {protAmountCh > 0 ? (
                            <span className="green">
                              +{parseFloat(protAmountCh)?.toFixed(2)}%
                            </span>
                          ) : protAmountCh < 0 ? (
                            <span className="red">
                              {parseFloat(protAmountCh)?.toFixed(2)}%
                            </span>
                          ) : (
                            <span className="">{parseInt(protAmountCh)}%</span>
                          )}
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="bottom-text">
                    <p className="uni-text">
                      <span></span>
                      {statsData?.protectedStats?.length > 0
                        ? parseFloat(
                            statsData?.protectedStats[0]?.totalEth * 0.75 || 0
                          )?.toFixed(5)
                        : 0}{" "}
                      ETH
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {statsData?.protectedStats?.length > 0
                        ? formatTokenValue(
                            statsData?.protectedStats[0]?.totalUsdt * 0.75 || 0
                          )
                        : 0}{" "}
                      USDT
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {statsData?.protectedStats?.length > 0
                        ? formatTokenValue(
                            statsData?.protectedStats[0]?.totalUsdc * 0.75 || 0
                          )
                        : 0}{" "}
                      USDC
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {statsData?.protectedStats?.length > 0
                        ? formatTokenValue(
                            statsData?.protectedStats[0]?.totalGems * 0.75 || 0
                          )
                        : 0}{" "}
                      GEMS
                    </p>
                  </div>
                </div>
                <div className="single-card">
                  <div className="inner-parent">
                    <div className="twice-set-items">
                      <div className="left-img">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_6684_7343)">
                            <path
                              d="M19.4622 15.1138L17.4776 17.0984L16.7142 16.3351C16.4613 16.0821 16.0512 16.0821 15.7983 16.3351C15.5453 16.588 15.5453 16.9981 15.7983 17.251L17.0196 18.4723C17.146 18.5988 17.3118 18.662 17.4775 18.662C17.6432 18.662 17.8091 18.5988 17.9355 18.4723L20.3781 16.0297C20.631 15.7768 20.631 15.3667 20.3781 15.1138C20.1253 14.8608 19.7152 14.8608 19.4622 15.1138Z"
                              fill="#fff"
                            />
                            <path
                              d="M10.3873 14.9107C10.2873 14.8754 10.1854 14.8386 10.0834 14.8007V12.9742C10.2708 13.0388 10.3678 13.1328 10.3806 13.1458C10.5768 13.3676 10.9156 13.3899 11.1393 13.195C11.364 12.9991 11.3875 12.6582 11.1916 12.4335C11.0072 12.2219 10.6248 11.9564 10.0834 11.8658V11.5683C10.0834 11.2702 9.84174 11.0286 9.54364 11.0286C9.24553 11.0286 9.0039 11.2702 9.0039 11.5683V11.9257C8.96607 11.9355 8.92795 11.9461 8.88939 11.9577C8.23687 12.1543 7.74955 12.7115 7.61755 13.4118C7.49652 14.054 7.70477 14.6752 8.16091 15.033C8.37927 15.2043 8.64582 15.3613 9.0039 15.5248V17.8959C8.74271 17.8612 8.54737 17.7758 8.24131 17.5756C7.99183 17.4124 7.65736 17.4823 7.49419 17.7318C7.33101 17.9813 7.40092 18.3158 7.65041 18.4789C8.17965 18.8251 8.55173 18.9444 9.0039 18.9818V19.3405C9.0039 19.6386 9.24553 19.8803 9.54364 19.8803C9.84174 19.8803 10.0834 19.6386 10.0834 19.3405V18.9314C10.438 18.8446 10.7606 18.6728 11.0337 18.4218C11.399 18.0862 11.6455 17.6315 11.7279 17.1415C11.8973 16.1341 11.3711 15.2584 10.3873 14.9107ZM8.82712 14.1837C8.69137 14.0772 8.63295 13.8527 8.67837 13.6118C8.71266 13.4299 8.81534 13.2188 9.0039 13.087V14.3061C8.93995 14.2661 8.88023 14.2253 8.82712 14.1837ZM10.6634 16.9626C10.6108 17.2751 10.4143 17.6049 10.0834 17.7834V15.9497C10.7162 16.2034 10.7009 16.7393 10.6634 16.9626Z"
                              fill="#fff"
                            />
                            <path
                              d="M22.4061 12.2592C21.5877 12.2592 20.8519 11.8044 20.4858 11.0724L20.3947 10.8901C20.285 10.6706 20.0607 10.532 19.8154 10.532H16.3611C16.1157 10.532 15.8915 10.6706 15.7817 10.8901L15.6906 11.0724C15.6555 11.1425 15.617 11.2102 15.5754 11.2751C14.6912 10.0827 13.7095 9.02159 12.8204 8.10904V5.99267C13.6799 4.77925 14.1158 3.44584 14.1158 2.02576V1.59397C14.1158 1.23628 13.8258 0.946289 13.4681 0.946289H13.0363C11.8368 0.946289 10.2722 1.72317 9.58197 2.10116C8.89176 1.72317 7.32716 0.946289 6.12765 0.946289H5.69586C5.33817 0.946289 5.04818 1.23628 5.04818 1.59397V2.02576C5.04818 3.44579 5.48402 4.77925 6.34355 5.99271V8.1093C3.64339 10.885 0.946167 14.2282 0.946167 18.0884L0.94621 18.1348C0.952255 20.8472 3.19545 23.054 5.94677 23.054H13.2172C14.2415 23.054 15.2388 22.7406 16.0758 22.1637C16.6315 22.5385 17.2447 22.8294 17.9021 23.0266C17.9628 23.0448 18.0255 23.054 18.0882 23.054C18.151 23.054 18.2136 23.0448 18.2744 23.0266C19.6662 22.6091 20.8605 21.7721 21.7279 20.6063C22.5954 19.4404 23.0538 18.056 23.0538 16.6029V12.9069C23.0538 12.5492 22.7638 12.2592 22.4061 12.2592ZM7.63892 6.43003H11.525V7.7254H7.63892V6.43003ZM9.24971 3.40214C9.45412 3.52429 9.7094 3.52429 9.91398 3.40227C10.4159 3.10295 11.8417 2.36092 12.8159 2.25444C12.7748 3.28521 12.454 4.23226 11.8399 5.13466H7.3241C6.70996 4.23221 6.38914 3.28517 6.34808 2.25444C7.3222 2.36092 8.74806 3.10295 9.24971 3.40214ZM5.94677 21.7586C3.90816 21.7586 2.24603 20.1317 2.24158 18.1325L2.24154 18.0884C2.24154 14.6919 4.74873 11.6073 7.26391 9.02077H11.9002C12.7699 9.91371 13.7286 10.9507 14.5771 12.1036C14.3259 12.2049 14.0531 12.2592 13.7703 12.2592C13.4126 12.2592 13.1227 12.5492 13.1227 12.9069V16.6029C13.1227 18.056 13.5811 19.4404 14.4486 20.6063C14.6287 20.8483 14.823 21.0759 15.0302 21.2888C14.4787 21.5942 13.8552 21.7586 13.2172 21.7586H5.94677ZM21.7585 16.6029C21.7585 18.9456 20.2916 20.9806 18.0882 21.7265C15.8849 20.9806 14.418 18.9456 14.418 16.6029V13.4942C15.3982 13.3092 16.2504 12.7083 16.7551 11.8274H19.4214C19.9261 12.7083 20.7783 13.3092 21.7585 13.4942V16.6029Z"
                              fill="#fff"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_6684_7343">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div className="right-stats">
                        <p className="mt-0">Miners Protected</p>
                        <h6>
                          {statsData?.protectedStats?.length > 0
                            ? parseInt(
                                statsData?.protectedStats[0]?.totalNftSum || 0
                              )
                            : 0}{" "}
                          {protNftAmountCh > 0 ? (
                            <span className="green">
                              +{parseFloat(protNftAmountCh)?.toFixed(2)}%
                            </span>
                          ) : protNftAmountCh < 0 ? (
                            <span className="red">
                              {parseFloat(protNftAmountCh)?.toFixed(2)}%
                            </span>
                          ) : (
                            <span className="">
                              {parseInt(protNftAmountCh)}%
                            </span>
                          )}
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="bottom-text">
                    <p className="uni-text">
                      <span></span>
                      {statsData?.protectednftQuantity?.length > 0
                        ? parseInt(
                            statsData?.protectednftQuantity[0]
                              ?.summedArray[0] || 0
                          )
                        : 0}{" "}
                      Mini
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {statsData?.protectednftQuantity?.length > 0
                        ? parseInt(
                            statsData?.protectednftQuantity[0]
                              ?.summedArray[1] || 0
                          )
                        : 0}{" "}
                      Miner
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {statsData?.protectednftQuantity?.length > 0
                        ? parseInt(
                            statsData?.protectednftQuantity[0]
                              ?.summedArray[2] || 0
                          )
                        : 0}{" "}
                      Mega
                    </p>
                  </div>
                </div>
              </>
            ) : null}
          </div>

          <div className="twice-charts">
            <div className="main-graph">
              <div className="graphheading">
                <h6 className="main-heading">
                  Top 10 Countries by Number of Purchases
                </h6>
                {/* <a
                  className="seealllink"
                  onClick={() => {
                    hitfunctionss(13);
                    dispatch(chartData(statsData?.countryWisePurchases));
                  }}
                >
                  See All
                </a> */}
              </div>

              <Countrychart
                chartData={chartsData?.purchasesNumberStats}
                chartType={"purchases"}
                seeAll={false}
              />
            </div>
            <div className="main-graph">
              <div className="graphheading">
                <h6 className="main-heading">
                  Top 10 Countries by Purchased Amount
                </h6>
                {/* <a
                  className="seealllink"
                  onClick={() => {
                    hitfunctionss(14);
                    dispatch(chartData(statsData?.countryWiseAmount));
                  }}
                >
                  See All
                </a> */}
              </div>
              <Countrychart
                chartData={chartsData?.purchaseAmountStats}
                chartType={"amount"}
                seeAll={false}
              />
            </div>
          </div>

          <DataTable
            btcPrice={btcPrice}
            tomiPrice={tomiPrice}
            pepePrice={pepePrice}
            linkPrice={linkPrice}
            uniPrice={uniPrice}
            dopPrice={dopPrice}
            gemsPrice={gemsPrice}
            setSearch={setSearch}
            setTopLeaderSearch={setTopLeaderSearch}
            user={user}
            getTransactionsData={getTransactionsData}
            usdPrice={usdPrice}
            transactions={transactions}
            topTenApiCalled={topTenApiCalled}
            topTenLeaders={topTenLeaders}
            loader={loader}
            setOrderDirection={setOrderDirection}
            setOrderField={setOrderField}
            setActiveTab={setActiveTab}
            activeTab={activeTab}
            project={selectedItem?.text}
          />
        </div>
      </section>

      <Modal
        className="add-mega-modal global-modal-scss"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          {user?.role === "admin" ? (
            <Modal.Title>Add God Leader</Modal.Title>
          ) : (
            <Modal.Title>Add Leader</Modal.Title>
          )}
          {/* {user?.role === "admin" && <Modal.Title>Add Mega Agents</Modal.Title>}
                    {user?.role === "admin" && <Modal.Title>Add Mega Agents</Modal.Title>} */}
        </Modal.Header>
        <Modal.Body>
          <div className="add-mega-div">
            <div className="option-field">
              <div className="material-textfield">
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter Leader’s Name"
                />
                {/* <label>Leader’s Name</label> */}
              </div>
            </div>
            <div className="option-field">
              <div className="material-textfield">
                <input
                  type="text"
                  value={addr}
                  onChange={(e) => setAddr(e.target.value)}
                  placeholder="Enter Leader’s Wallet Address"
                />
                {/* <label>Leader’s Wallet Address</label> */}
              </div>
            </div>
            <div className="option-field">
              <div className="material-textfield">
                <input
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  type="text"
                  placeholder="Enter Leader’s Email Address"
                />
                {/* <label>Leader’s Email Address</label> */}
              </div>
            </div>
            {user?.role !== "admin" && (
              <div className="option-field">
                <div class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {role === null
                      ? "Type of Leader"
                      : convertToTitleCase(role)}
                  </button>
                  {user?.role === "god_agent" && (
                    <ul class="dropdown-menu">
                      <li onClick={() => setRole("mega_agent")}>
                        <a class="dropdown-item" href="#">
                          Mega Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("super_agent")}>
                        <a class="dropdown-item" href="#">
                          Super Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("agent")}>
                        <a class="dropdown-item" href="#">
                          Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("mini_agent")}>
                        <a class="dropdown-item" href="#">
                          Ambassador
                        </a>
                      </li>
                    </ul>
                  )}
                  {user?.role === "mega_agent" && (
                    <ul class="dropdown-menu">
                      <li onClick={() => setRole("super_agent")}>
                        <a class="dropdown-item" href="#">
                          Super Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("agent")}>
                        <a class="dropdown-item" href="#">
                          Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("mini_agent")}>
                        <a class="dropdown-item" href="#">
                          Ambassador
                        </a>
                      </li>
                    </ul>
                  )}
                  {user?.role === "super_agent" && (
                    <ul class="dropdown-menu">
                      <li onClick={() => setRole("agent")}>
                        <a class="dropdown-item" href="#">
                          Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("mini_agent")}>
                        <a class="dropdown-item" href="#">
                          Ambassador
                        </a>
                      </li>
                    </ul>
                  )}
                  {user?.role === "agent" && (
                    <ul class="dropdown-menu">
                      <li onClick={() => setRole("mini_agent")}>
                        <a class="dropdown-item" href="#">
                          Ambassador
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </div>
            )}
          </div>
          <p
            style={{
              color: "red",
              textAlign: "center",
              marginTop: -15,
              marginBottom: 15,
            }}
          >
            {error}
          </p>
          <div className="twice-btn">
            <button
              onClick={() => {
                handleClose1();
                setError("");
              }}
              className="btn-cancel"
            >
              Back
            </button>
            <button
              disabled={loader}
              className="btn-add"
              onClick={() => AddAgent()}
            >
              {loader ? "Adding..." : "Add"}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="add-mega-modal global-modal-scss"
        show={show2}
        onHide={handleClose2}
        centered
      >
        <Modal.Header closeButton>
          {user?.role === "admin" ? (
            <Modal.Title>Add Mega Leaders</Modal.Title>
          ) : (
            <Modal.Title>Add Leaders</Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          <div className="add-mega-div">
            {user?.role === "admin" ? (
              <h6>God Leader has been added</h6>
            ) : (
              <h6>
                {convertToTitleCase(role)}{" "}
                {convertToTitleCase(role) === "Leader"
                  ? "has been added"
                  : convertToTitleCase(role) === "Mega Leader" ||
                    convertToTitleCase(role) === "Ambassador"
                  ? "has been added"
                  : "Leader has been added"}
              </h6>
            )}
          </div>
          <div className="twice-btn">
            <button
              onClick={() => handleClose2()}
              className="btn-add"
              style={{ flex: "auto" }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Dashboard;
